import mapboxCSS from 'mapbox-gl/src/css/mapbox-gl.css'

export const MAP_FLOATING_WIDGET_SPACING = 8

export const getMapboxBaseStyles = () => {
  return `
    ${mapboxCSS}
  `
}
